import { Box, Flex, Group, Stack, Text } from "@mantine/core";
import { FC, useState } from "react";
import { ColorType } from "../FunnelModal/ColorsPanel";
import { SPECIALTY_COLOR_MAP, STATUS_COLOR_MAP, TYPE_TITLE_MAP } from "../FunnelModal/consts";
import { ReactComponent as ExpandIcon } from 'assets/caretleft.svg';
import { DEFAULT_PIN_COLOR } from "Modules/Map";
import { END_CHECK_IN_SCALE } from "../FunnelModal/FiltersPanel";

interface Props {
  colorControl: ColorType;
  isVisible?: boolean;
};

const ColorLabel: FC<Props> = ({ colorControl, isVisible }) => {
  const [expanded, setExpanded] = useState(false);
  const isDiscrete = (colorControl === "specialty-type" || colorControl === "status");
  return (
    <>
      {isVisible ? (
        <Box
          bg="#4F7D9C" w="100vw">
          {isDiscrete ? (
            <Box pos="relative" px={20} py={10} my={0} mah={expanded ? 9999 : 60}
              style={{
                overflowY: "hidden",
                transition: "max-height 0.3s ease-in-out",
              }} >
              {colorControl === "specialty-type" ? (
                <Flex w="80%" gap={12} align="center" justify="center" wrap="wrap">
                  {[...SPECIALTY_COLOR_MAP.entries()].map(([k, v], index) => (
                    <Group key={index} gap={3} align="center">
                      <Box w={10} h={10} bg={v}>
                      </Box>
                      <Text c="white" fz={8}>
                        {k}
                      </Text>
                    </Group>
                  ))}
                </Flex>
              ) : (
                <Flex w="90%" gap={12} align="center" justify="center" wrap="wrap"
                  style={{ boxSizing: "border-box" }}>
                  {[...STATUS_COLOR_MAP.entries()].map(([k, v], index) => (
                    <Group key={index} gap={3} align="center">
                      <Box w={10} h={10} bg={v}>
                      </Box>
                      <Text c="white" fz={8}>
                        {k}
                      </Text>
                    </Group>
                  ))}
                </Flex>
              )}
              <Box style={{
                position: "absolute",
                top: 5,
                right: 5,
                width: "10%",
                boxSizing: "border-box"
              }}>
                <Stack gap={0} align="center">
                  <ExpandIcon
                    style={{

                      transform: expanded ? "rotate(270deg)" : "rotate(90deg)",
                      color: "white",
                    }}
                    onClick={() => setExpanded((prev) => !prev)}
                  />
                  <Text c="white" fz={9}>
                    {expanded ? "MINIMIZE" : "EXPAND"}
                  </Text>
                </Stack>
              </Box>
            </Box>
          ) : (
            <Box h={60} >
              <Stack gap={0} align="center">
                <Text ta="center" c="white" fw="bold" fz={12} my={10}>
                  {TYPE_TITLE_MAP.get(colorControl)}
                </Text>
                <Box
                  h={10} w="70%" pos="relative"
                  bg="linear-gradient(90deg, #FF9D00 0%, #8B0000 100%)">
                  <Text pos="absolute" left={-20} top={-3} c="white" fz={10}>
                    0
                  </Text>
                  <Text pos="absolute" right={-35} top={-3} c="white" fz={10}>
                    {END_CHECK_IN_SCALE}
                  </Text>
                </Box>
              </Stack>
            </Box>
          )}
        </Box>
      ) : null}
    </>
  );
};


export const valueToGradientColor = (value: number): string => {
  const min = 0;
  const max = END_CHECK_IN_SCALE;
  const clamped = Math.min(Math.max(value, min), max);

  const t = (clamped - min) / (max - min); // 0 ≤ t ≤ 1

  const start = { r: 0xff, g: 0x9d, b: 0x00 }; // #FF9D00
  const end = { r: 0x8B, g: 0x00, b: 0x00 }; // #8B0000

  const lerp = (a: number, b: number) => Math.round(a + (b - a) * t);
  const r = lerp(start.r, end.r);
  const g = lerp(start.g, end.g);
  const b = lerp(start.b, end.b);

  const toHex = (n: number) => n.toString(16).padStart(2, '0').toUpperCase();

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};

export const valueToColor = (v: string, colorControl: ColorType) => {
  if (colorControl === "specialty-type") {
    if (SPECIALTY_COLOR_MAP.get(v)) {
      return SPECIALTY_COLOR_MAP.get(v);
    }
  } else {
    if (STATUS_COLOR_MAP.get(v)) {
      return STATUS_COLOR_MAP.get(v);
    }
  }
  return DEFAULT_PIN_COLOR;
}


export default ColorLabel;
